module.exports = __webpack_public_path__ + "img/logo.f18cb398.png";